<div class="suggestion">{{ 'SuggestionMessages.SearchFailed' | translate }}</div>
<div class="actions">
  <button class="btn btn-primary" (click)="search()">{{ 'Common.Begin' | translate }}</button>
  <button class="btn btn-danger" (click)="close()">{{ 'Common.Close' | translate }}</button>
</div>
